// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_160w_animationWrapper__mt_Vi"};